module.exports = __webpack_public_path__ + "img/xe-logo.9a3d8dfb.png";